import runtime from '../platformAssets/renative.runtime.json';

type ProductRuntime = {
  productProfile?: 'private' | 'public';
  privateBackendEnabled?: boolean;
  aggressiveOptimizationsEnabled?: boolean;
  presetServerUrl?: string;
  appVersion?: string;
  appVersionCode?: number;
  androidUpdateManifestUrl?: string;
};

const configured = runtime as ProductRuntime;

export const productProfile = {
  kind: configured.productProfile === 'public' ? 'public' : 'private',
  privateBackendEnabled: configured.privateBackendEnabled !== false,
  aggressiveOptimizationsEnabled: configured.aggressiveOptimizationsEnabled !== false,
  presetServerUrl: configured.presetServerUrl?.trim() ?? 'https://remux.obnoxious.lol',
  appVersion: configured.appVersion?.trim() ?? '',
  appVersionCode: Number.isInteger(configured.appVersionCode) ? configured.appVersionCode ?? 0 : 0,
  androidUpdateManifestUrl: configured.androidUpdateManifestUrl?.trim() ?? '',
} as const;

export const isPublicProduct = productProfile.kind === 'public';
